import { render } from "./CompanyAssetCreateEditModal.vue?vue&type=template&id=59c12de6"
import script from "./CompanyAssetCreateEditModal.vue?vue&type=script&lang=js"
export * from "./CompanyAssetCreateEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__